import React from 'react';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    size?: number;
};

const Divider02Icon = ({ color = 'currentColor', size = 24, ...props }: Props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={size} height={size} {...props}>
        <path
            fill={color}
            d="M21 13a1 1 0 1 0 0-2v2M3 11a1 1 0 1 0 0 2v-2m18 1v-1H3v2h18zM7 16v1h10v-2H7zm12 2h-1v1h2v-1zm-2 3v-1H7v2h10zM5 19h1v-1H4v1zm2 2v-1a1 1 0 0 1-1-1H4a3 3 0 0 0 3 3zm12-2h-1a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-2-3v1a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zM7 16v-1a3 3 0 0 0-3 3h2a1 1 0 0 1 1-1zM7 3v1h10V2H7zm12 2h-1v1h2V5zm-2 3V7H7v2h10zM5 6h1V5H4v1zm2 2V7a1 1 0 0 1-1-1H4a3 3 0 0 0 3 3zm12-2h-1a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-2-3v1a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zM7 3V2a3 3 0 0 0-3 3h2a1 1 0 0 1 1-1z"
        />
    </svg>
);
export { Divider02Icon };
